import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-tryout-discount-scholarships',
  templateUrl: './tryout-discount-scholarships.component.html',
  styleUrls: ['./tryout-discount-scholarships.component.css']
})
export class TryoutDiscountScholarshipsComponent implements OnInit {

  @Input() DiscountScholarships: number;

  //@Output() filterProgramsEvent = new EventEmitter();
  //program_status = '';

  constructor() { }

  ngOnInit() {
  }

  //filterProgramListing(value) {
  //  this.program_status = value;
  //  //this.filterProgramsEvent.emit(this.program_status);
  //}
}



// WEBPACK FOOTER //
// ./src/app/tryout/components/tryout-discount-scholarships/tryout-discount-scholarships.component.ts